export enum RewardType {
  TTB = 'ttb',
  TTP = 'ttp',
  Beans = 'beans',
  Bottle = 'bottle',
  ShellCoin = 'shell_coin',
  // 勋章
  Medal = 'medal',
  // 福卡
  LuckyCard = 'lucky_card',
  // 活动币
  ActivityCoin = 'activity_coin',
  ActivityCandy = 'activity_candy',
  // 实物
  Physical = 'physical',
  PhysicalSize = 'physical_size',
  // 赠送vip
  SSplusCoupon = 'super_vip_coupon',
  // 体验vip
  SSplusCouponSelf = 'super_vip_coupon_self',
  // 头像框
  AvatarFrame = 'avatar_frame',
  // 运动卡
  SportsCardHolder = 'sport_card_holder',
  SportsCardDiamond = 'card_diamond',
  // 运动岛
  SportsIslandGift = 'gift_prop',
  SportsIslandSkin = 'island_skin',
  SportsIslandVehicle = 'island_vehicle',
  SportsIslandFurniture = 'island_furniture',
  SportsIslandInteractiveProps = 'island_interactive_props',
  // 切水果
  FruitCoin = 'fruit_coin',
  FruitSkin = 'fruit_skin',
  // 运动秀
  SportsShowSuit = 'sport_show_suit',
  SportsShowFace = 'sport_show_face',
  SportsShowCloth = 'sport_show_cloth',
  SportsShowEquip = 'sport_show_equip',
  // 爆破英雄
  BlastSkin = 'blast_skin',
  BlastCoin = 'blast_coin',
  BlastTicket = 'blast_ticket',
  BlastTicketFire = 'blast_ticket_fire',
  BlastTicketTrack = 'blast_ticket_track',
  BlastTicketSmall = 'blast_ticket_small',
  BlastTicketFollow = 'blast_ticket_follow',
  // 火枪手
  EggPet = 'egg_pet',
  EggCoin = 'egg_coin',
  EggWeapon = 'egg_weapon',
  EggDiamond = 'egg_diamond',
  EggBattery = 'egg_battery',
  // 跑酷
  ParkourProp = 'parkour_prop',
  // 龙骑士
  DragonKnightEquip = 'dragon_knight_equip',
  DragonKnightDragon = 'dragon_knight_dragon',
  DragonKnightCrystal = 'dragon_knight_crystal',
  DragonKnightNormalEgg = 'dragon_knight_normal_egg',
  // 动感跳糕
  SuperPastrySkin = 'super_pastry_skin',
  //农场岛
  IslandFertilizer = 'island_fertilizer',
  // 体感打怪兽
  MonsterExp = 'monster_exp',
  MonsterRole = 'monster_role',
  MonsterGold = 'monster_gold',
  MonsterDiamond = 'monster_diamond',
  // 天天下蛋龙
  SquatEgg = 'squat_egg',
  SquatRole = 'squat_role',
  SquatDiamond = 'squat_diamond',
  SquatEggShell = 'squat_egg_shell',
  SquatGoldCoin = 'squat_gold_coin',
  SquatNormalTicket = 'squat_normal_ticket',
  SquatRoleFragment = 'squat_role_fragment',
  SquatAncientTicket = 'squat_ancient_ticket',
  SquatDefenceDiamond = 'squat_defence_diamond',
  // 大操场热度礼物
  BigPlayHotGift = 'big_play_hot_gift',
  // 查看物流
  ViewLogistics = 'view_logistics',
}

export enum RewardTypeKoiFish {
  TTP = 'ttpoint',
  ShellCoin = 'star_shell',
  // 活动币
  ActivityCoin = 'magic_stone',
  // 勋章
  Medal = 'medal',
  // 实物
  Physical = 'physical_reward',
  // 赠送vip
  SSplusCoupon = 'give_member_sku',
  // 体验vip
  SSplusCouponSelf = 'member_sku',
  // 头像框
  AvatarFrame = 'avatar_decoration',
  // 运动卡
  SportsCardDiamond = 'card_diamond',
  // 运动岛
  SportsIslandFurniture = 'sports_island_item',
  // 龙骑士
  DragonKnightCrystal = 'dragon_knight_crystal',
  DragonKnightNormalEgg = 'dragon_knight_normal_egg',
}

// 体智云奖品类型
export enum E_REWARD_ITEM_TYPE {
  // 虚拟会员
  C_S_PLUS = 'C_S_PLUS',
  // 运动秀套装
  C_SUIT = 'C_SUIT',
  // 运动秀套装
  C_CLOTHING = 'C_CLOTHING',
  // 火枪手体力
  C_EGG_BATTERY = 'C_EGG_BATTERY',
  // 火枪手金币
  C_EGG_COIN = 'C_EGG_COIN',
  // 火枪手钻石
  C_EGG_DIAMOND = 'C_EGG_DIAMOND',
  // # 火枪手武器
  C_EGG_WEAPON = 'C_EGG_WEAPON',
  // # 体感切水果刀
  C_GAME_FRUIT_KNIFE = 'C_GAME_FRUIT_KNIFE',
  // # 切水果场景
  C_GAME_FRUIT_SCENE = 'C_GAME_FRUIT_SCENE',
  // # 杨桃币
  C_GAME_FRUIT_STARFRUIT = 'C_GAME_FRUIT_STARFRUIT',
  // # 装备
  C_EQUIPMENT = 'C_EQUIPMENT',
  // # 爆破英雄背景
  C_BLAST_SCENE = 'C_BLAST_SCENE',
  // # 爆破英雄道具
  C_BLAST_TICKET = 'C_BLAST_TICKET',
  // # 爆破英雄炮塔皮肤
  C_BLAST_CANNON_SKIN = 'C_BLAST_CANNON_SKIN',
  // # 爆破英雄球球皮肤
  C_BLAST_BALL_SKIN = 'C_BLAST_CANNON_SKIN',
  // # 能量豆
  C_ENERGY_BEAN = 'C_ENERGY_BEAN',
  // # 扭蛋瓶
  C_TWIST_BOTTLE = 'C_TWIST_BOTTLE',
  // 虚拟商品
  C_VIRTUAL_PRODUCT = 'C_VIRTUAL_PRODUCT',

  // # 星贝壳
  C_STAR_SHELL = 'C_STAR_SHELL',
  // # 飞龙龙蛋
  C_DRAGON_EGG = 'C_DRAGON_EGG',
  // # 飞龙金币
  C_DRAGON_COIN = 'C_DRAGON_COIN',
  // # 飞龙龙晶
  C_DRAGON_CRYSTAL = 'C_DRAGON_CRYSTAL',
  // # 飞龙
  C_DRAGON = 'C_DRAGON',
  // # 卡钻
  C_CARD_DIAMOND = 'C_CARD_DIAMOND',
  // # 跑酷道具
  C_PARKOUR_PROPS = 'C_PARKOUR_PROPS',
  // # 跑酷护盾
  C_PARKOUR_SHIELD = 'C_PARKOUR_SHIELD',
  // # 跑酷金币
  C_PARKOUR_COIN = 'C_PARKOUR_COIN',
  // # 运动岛家具
  C_ISLAND_FURNITURE = 'C_ISLAND_FURNITURE',
  // 卡包
  C_CARD_PACKAGE = 'C_CARD_PACKAGE',
  // 勋章
  MEDAL = 'MEDAL',
  // 跳糕道具
  C_PASTRY_SKIN = 'C_PASTRY_SKIN',
  // 体智云积分实物奖励
  TZY_MT_POINTS_PHYSICAL = 'TZY_MT_POINTS_PHYSICAL',
  // 体智云积分学校奖励
  TZY_MP_SCHOOL_REWARD = 'TZY_MP_SCHOOL_REWARD',
}

export interface IRewardTransQuantity {
  value: number | string
  style?: Record<string, string>
  positiveSign?: string
}

export interface IRewardTransImage {
  bg: string
  rewardIcon: string
  quantity?: IRewardTransQuantity | null
}

export interface IReward {
  icon: string
  name: string
  time: string
  data?: any
  action?: () => void | Promise<void>
  btnType: string
  btnLabel: string
  disabled: boolean
  transReward?: IRewardTransImage
}

export interface IRewardPopupReward {
  id?: string
  data?: any
  text?: string
  tips?: string

  title: {
    image: string
    label: string
    width?: number
    height?: number
  }

  reward: {
    name: string
    image: string
    width?: number
    height?: number
  }

  btnOk: {
    image: string
    label: string
    width?: number
    height?: number
    action?: () => void | Promise<void>
  }
}

export interface IRewardPopupRewards {
  id?: string
  data?: any
  text?: string
  tips?: string

  title: {
    image: string
    label: string
    style?: Record<string, string | undefined>
    width?: number
    height?: number
  }

  rewardsCol?: number
  rewards: Array<{
    id: string | number
    name: string
    nameStyle?: Record<string, string>
    data?: any
    image: string
    icon?: string
    iconClass?: string
    width?: number
    height?: number
    quantity?: {
      value: number | string
      style?: Record<string, string>
      positiveSign?: string
      // @deprecated - use style instead
      color?: string
      // @deprecated - use style instead
      borderColor?: string
    } | null
    transReward?: IRewardTransImage
  }>

  btnOk: {
    image: string
    label: string
    width?: number
    height?: number
    action?: () => void | Promise<void>
  }

  btnAdditional?: {
    label?: string
    action?: () => void | Promise<void>
  } | null
}
